import {Outlet, useLocation, useNavigate} from "react-router-dom"
import {AdminMenu} from "pages/admin/menu/AdminMenu"
import {useEffect} from "react"

export const Admin = () => {
    const location = useLocation()
    const navigate = useNavigate()
    useEffect(() => {
        if(location.pathname === "/admin" || location.pathname === "/admin/") {
            navigate("/admin/devices")
        }
    }, [location.pathname, navigate])
    return (
        <div className="admin-wrapper">
            <AdminMenu/>
            <Outlet/>
        </div>
    )
}
